import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 710,
  firstName: "Chander Shekhar",
  lastName: "Saini",
  username: "dtfirmadmin",
  radiologistType: 0,
  firmId: 571,
  firmName: "DeepTek Teleradiology",
  lastResetPasswordDate: "2022-10-20",
  authorities: [
    {
      authority: "FIRM_ADMIN",
    },
  ],
  provider: "LOCAL",
  forceReset: false,
};

export const userPrincipalSlice = createSlice ({
    name: "userPrincipal",
    initialState: {value: initialState}, 
    reducers: {
        saveUserPrincipal : (state, action) => {
            // console.log(action.payload)
            state.value = action.payload;
        },
        deleteUserPrincipal : (state) => {
            state.value = initialState;
        }
    }
})

export const {saveUserPrincipal, deleteUserPrincipal} = userPrincipalSlice.actions;

export default userPrincipalSlice.reducer;